import axios, { AxiosResponse } from 'axios'
import { API_URL } from '../../../../../../constants'
import { ApiResponse } from '../../../../../common/api/response.types'
import { dedupe } from '../../Dashboard/core/api'
import { DASHBOARD_API } from '../../Dashboard/core/consts'
import { PoolFillResponse } from './types'

/**
 * Заполненность пула активных выплат за 72 часа. merchant / paymentMethod —
 * внутренние id, необязательны; срез входит в ключ дедупликации.
 */
export const getPayoutPoolFill = (
  currency: string,
  filter?: { merchant?: number; paymentMethod?: number }
) =>
  dedupe<AxiosResponse<ApiResponse<PoolFillResponse>>>(
    `pool-fill:${currency}:${filter?.merchant ?? ''}:${filter?.paymentMethod ?? ''}`,
    () =>
      axios.get<ApiResponse<PoolFillResponse>>(`${API_URL}${DASHBOARD_API}/payout-pool-fill`, {
        params: {
          currency,
          ...(filter?.merchant ? { merchant: filter.merchant } : {}),
          ...(filter?.paymentMethod ? { paymentMethod: filter.paymentMethod } : {}),
        },
      })
  )
